export default {
  items: [
    {
      title: true,
      name: "Work",
      wrapper: {
        element: "span",
        attributes: {},
      },
      class: "",
    },
    {
      name: "Jobs",
      url: "/jobs",
      icon: "fal fa-briefcase",
    },
    {
      name: "Customers",
      url: "/customers/list",
      icon: "fal fa-head-side",
    },

    {
      title: true,
      name: "Admin",
      wrapper: {
        element: "span",
        attributes: {},
      },
      class: "mt-3",
    },

    {
      name: "Invoices",
      url: "/invoices/list",
      icon: "fal fa-wallet",
    },
    {
      name: "Media",
      url: "/media/list",
      icon: "fal fa-images",
    },
    {
      name: "Reminders",
      url: "/reminders/list",
      icon: "fal fa-alarm-exclamation",
    },

    {
      title: true,
      name: "Settings",
      wrapper: {
        element: "span",
        attributes: {},
      },
      class: "mt-3",
    },
    {
      name: "Users",
      url: "/users/list",
      icon: "fal fa-users-class",
    },
    {
      name: "Tributes",
      url: "/tributes/list",
      icon: "fal fa-hand-holding-heart",
    },
    {
      name: "Vouchers",
      url: "/vouchers/list",
      icon: "fal fa-gift-card",
    },
    {
      name: "Public Holidays",
      url: "/public-holidays/list",
      icon: "fal fa-calendar-star",
    },
    {
      name: "OrgChart",
      url: "/designations/chart",
      icon: "fal fa-user-crown",
    },
    {
      name: "Brands",
      url: "/brands/list",
      icon: "fal fa-layer-group",
    },

    {
      name: "Logout",
      url: "/logout",
      icon: "fal fa-sign-out",
      class: "mt-auto mb-3",
    },
  ],
};
